import React from "react";
import { Link } from "react-router-dom";
import "../styles/Dashboard.css";

// Principal-only modules (add/see fees)
const PRINCIPAL_MODULES = [
  {
    title: "Manage Fees",
    description: "Add and review student fee records and payments batch-wise.",
    icon: "💳",
    link: "/principal/manage-fees"
  }
];

// Staff modules (all available to principal as principal is also staff)
const STAFF_MODULES = [
  {
    title: "Profile",
    description: "View your staff details and photo.",
    icon: "👤",
    link: "/principal/profile"
  },
  {
    title: "Attendance",
    description: "Mark and review student attendance for each batch and subject.",
    icon: "🗓️",
    link: "/principal/attendance"
  },
  {
    title: "Lesson Plan",
    description: "Upload and organize lesson plans, track syllabus coverage.",
    icon: "📚",
    link: "/principal/lessonplan"
  },
  {
    title: "Assessment",
    description: "Enter and review internal assessment marks and analytics.",
    icon: "📝",
    link: "/principal/assessment"
  },
  {
    title: "Clinical Posting",
    description: "Schedule, assign, and monitor clinical postings for students.",
    icon: "🏥",
    link: "/principal/clinical"
  },
  {
    title: "Rotation Plan",
    description: "Manage and schedule rotation plans for students and staff.",
    icon: "🔄",
    link: "/principal/rotation"
  },
  {
    title: "Notices",
    description: "View and publish important college notices and circulars.",
    icon: "📢",
    link: "/principal/notices"
  },
  {
    title: "Library",
    description: "Browse and share reference books and teaching resources.",
    icon: "📖",
    link: "/principal/library"
  },
  {
    title: "Reports",
    description: "Generate, view, and download academic reports.",
    icon: "📊",
    link: "/principal/reports"
  },
  {
    title: "Settings",
    description: "Manage your profile details and password.",
    icon: "⚙️",
    link: "/principal/settings"
  }
];

export default function PrincipalDashboard() {
  // Combine principal and staff modules
  const ALL_MODULES = [...PRINCIPAL_MODULES, ...STAFF_MODULES];

  return (
    <div className="dashboard-wrapper">
      <h2>Principal Dashboard</h2>
      <p>
        Welcome to the GNM College Principal Panel. You can manage fees and all staff academic modules.
      </p>
      <div className="dashboard-grid">
        {ALL_MODULES.map((mod) => (
          <Link 
            to={mod.link} 
            className="dashboard-card" 
            key={mod.title} 
            aria-label={mod.title}
            tabIndex={0}
          >
            <div className="dashboard-card-icon" style={{fontSize: 48}}>{mod.icon}</div>
            <div className="dashboard-card-title">{mod.title}</div>
            <div className="dashboard-card-desc">{mod.description}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}